
import Utils from '@utils/utils';
import { useImperativeHandle, forwardRef, useContext, useState, useRef, useMemo, useEffect } from "react"
import { AppContext } from "@utils/AppContext"
import styles from './index.module.scss'

const list = [{
    value: "clothes",
    item: [
        { img: 'sample1', label: '单件、无遮挡、清晰' },
        { img: 'sample2', label: '请勿上传上身图', error: true },
        { img: 'sample3', label: '请勿上传多件服装图', error: true },
        { img: 'sample4', label: '请勿上传模糊图片', error: true },
    ]
}, {
    value: "tryonBatch",
    item: [
        { img: 'sample1', label: '单件、无遮挡、清晰' },
        { img: 'sample2', label: '请勿上传上身图', error: true },
        { img: 'sample3', label: '请勿上传多件服装图', error: true },
        { img: 'sample4', label: '请勿上传模糊图片', error: true },
    ]
}, {
    value: "model",
    item: [
        { img: 'sample5', label: '清晰模特图' },
        { img: 'sample6', label: '模特光线过暗', error: true },
        { img: 'sample7', label: '模特主体模糊', error: true },
    ]
}, {
    value: "simRecolorBatch",
    item: [
        { img: 'sample5', label: '清晰模特图' },
        { img: 'sample6', label: '模特光线过暗', error: true },
        { img: 'sample7', label: '模特主体模糊', error: true },
    ]
}, {
    value: "imageFinerBatch",
    item: [
        { img: 'sample5', label: '清晰模特图' },
        { img: 'sample6', label: '模特光线过暗', error: true },
        { img: 'sample7', label: '模特主体模糊', error: true },
    ]
}, {
    value: "commodityStackingBatch",
    item: [
        { img: 'sample104', label: '商品清晰，PNG格式透明背景' },
        { img: 'sample105', label: '主、辅品相对大小与实际一致' },
        { img: 'sample106', label: '商品有遮挡', error: true },
        { img: 'sample107', label: '单图含多件商品', error: true },
    ]
}, {
    value: "changeModelBatch",
    item: [
        { img: 'sample5', label: '清晰模特图' },
        { img: 'sample6', label: '模特光线过暗', error: true },
        { img: 'sample7', label: '模特主体模糊', error: true },
    ]
}, {
    value: "changeBkgBatch",
    item: [
        { img: 'sample101', label: '清晰模特图' },
        { img: 'sample102', label: '模特光线过暗', error: true },
        { img: 'sample103', label: '模特主体模糊', error: true },
    ]
}, {
    value: "shoesTryon",
    item: [
        { img: 'sample8', label: '侧面俯拍鞋子图' },
        { img: 'sample9', label: '商品不完整', error: true },
        { img: 'sample10', label: '同款不同色', error: true },
    ]
}, {
    value: "clothRecolor",
    item: [
        { img: 'sample5', label: '清晰模特图' },
        { img: 'sample6', label: '模特光线过暗', error: true },
        { img: 'sample7', label: '模特主体模糊', error: true },
    ]
}, {
    value: "clothRecolor2",
    item: [
        { img: 'sample11', label: '清晰模特图' },
        { img: 'sample12', label: '与源素材版型一致，颜色不同', colspan: 2 },
        { img: 'sample13', label: '' },
    ]
}]

const ServiceSampleModal = forwardRef((props, ref) => {
    const [showList, setShowList] = useState([])

    useEffect(() => {
        if (!props.showValue) return
        const selectedItem = list.find(item => item.value === props.showValue)?.item;
        setShowList(selectedItem)
    }, [props.showValue])

    let width = 48
    const selectedItem = list.find(item => item.value === props.showValue)?.item;
    for (let item of selectedItem) {
        width += 160
    }
    width += 48 * (selectedItem.length - 1)

    return (
        <div
            className={styles.ServiceSampleStyl}
            style={{ width: width }}
        >
            {
                showList.map(item => (
                    <div key={item.img} className={`${styles.sampleItemStyl} ${item.colspan && styles[`colspan${item.colspan}`]}`}>
                        <img src={`https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/servicepage/${item.img}.png`} alt="" />
                        <p style={{ color: item.error ? '#FF0000' : '#262626' }}>
                            {item.label}
                        </p>
                    </div>
                ))
            }
        </div>
    )
})

export default ServiceSampleModal